//AddToCart SCartNotification

export const addToCart = {
        "ButtonMessage": "Añadir al carrito",
        "Message": "Nuevo producto añadido al carrito",
        "EndMessage": "fue añadido al carrito.",
        "EnableSnipcart": "disable"
};